import { useState } from "react";

const SECTORS = [
  "Restaurant / Bar / Café",
  "Boulangerie / Pâtisserie",
  "Coiffeur / Barbier",
  "Institut de beauté / Spa",
  "Médecin / Dentiste / Kiné",
  "Avocat / Notaire / Expert-comptable",
  "Plombier / Électricien / Artisan",
  "Garage / Réparation auto",
  "Agence immobilière",
  "Hôtel / Hébergement",
  "Commerce de détail",
  "Salle de sport / Coach",
  "Architecte / Designer",
  "Vétérinaire",
  "Opticien / Pharmacie",
  "Crèche / École privée",
  "Autre",
];

export default function RankDistrictLanding() {
  const [form, setForm] = useState({
    prenom: "", entreprise: "", email: "", telephone: "",
    ville: "", secteur: "", gbpUrl: "", siteWeb: "",
    dateDebut: "", message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [activeQuestion, setActiveQuestion] = useState(null);

  // ==================== ANALYTICS CONFIG ====================
  const GA_ID = 'G-XXXXXXXXXX';       // Remplace par ton GA4 ID
  const PIXEL_ID = 'XXXXXXXXXX';       // Remplace par ton Meta Pixel ID
  const WEBHOOK_URL = 'https://hook.eu1.make.com/upqjgald3n84tb1fhs5qtgaqyjlsl4bc'; // Remplace par ton webhook Make

  const update = (field, value) => {
    setForm(f => ({ ...f, [field]: value }));
    if (errors[field]) setErrors(e => ({ ...e, [field]: null }));
  };

  const validate = () => {
    const e = {};
    if (!form.prenom.trim()) e.prenom = "Requis";
    if (!form.entreprise.trim()) e.entreprise = "Requis";
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = "Email invalide";
    if (!form.ville.trim()) e.ville = "Requis";
    if (!form.secteur) e.secteur = "Requis";
    if (!form.gbpUrl.trim() || !(form.gbpUrl.includes("google") || form.gbpUrl.includes("goo.gl") || form.gbpUrl.includes("maps.app") || form.gbpUrl.includes("share.google"))) e.gbpUrl = "1/ Ouvrez Google Maps \u2192 votre fiche\n2/ Copiez l'URL (maps.google.com/?cid=...)\n3/ Collez ici";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (ev) => {
    if (ev) ev.preventDefault();
    if (!validate() || submitting) return;
    setSubmitting(true);
    setSubmitted(true);
    // Send data as URL-encoded (compatible Make.com nativement)
    const params = new URLSearchParams({ ...form, submitted_at: new Date().toISOString() });
    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString()
    })
      .then(() => {
        if (typeof window !== 'undefined') {
          if (window.gtag) window.gtag('event', 'generate_lead', { event_category: 'form', event_label: 'audit_gratuit' });
          if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Audit gratuit', content_category: form.secteur });
        }
      })
      .catch((err) => console.error('Webhook error:', err));
  };

  const faqData = [
    { q: "C'est vraiment gratuit ?", a: "Oui. L'audit est 100% gratuit, sans engagement. Vous recevez un rapport PDF complet avec votre score, vos forces, vos faiblesses, et un plan d'action concret. Pas de carte bancaire, pas de piège." },
    { q: "Qu'est-ce que vous analysez exactement ?", a: "Votre fiche Google Business Profile (catégories, description, photos, horaires, avis), votre positionnement Maps sur 20 zones GPS autour de votre adresse, vos mots-clés locaux, la cohérence entre votre site et votre fiche, vos Call-to-Action, et vos concurrents directs." },
    { q: "Combien de temps ça prend ?", a: "Sous 48h après soumission. Analyse automatisée + vérif humaine." },
    { q: "J'ai besoin de donner accès à ma fiche Google ?", a: "Non. L'audit gratuit fonctionne sans aucun accès à votre compte. On analyse uniquement ce qui est visible publiquement. Si vous devenez client, on pourra aller plus loin avec votre accord." },
    { q: "Et après l'audit, qu'est-ce qui se passe ?", a: "Rien si vous ne le souhaitez pas. Le rapport est à vous. Si les résultats vous intéressent, on peut en discuter ensemble et voir si un accompagnement mensuel fait sens pour votre activité." },
  ];

  // Styles
  const colors = {
    bg: "#0A0E1A",
    bgCard: "#1A2332",
    bgCardHover: "#222D3F",
    accent: "#3B82F6",
    accentGlow: "rgba(59,130,246,0.15)",
    accentBright: "#60A5FA",
    danger: "#EF4444",
    dangerSoft: "#FCA5A5",
    success: "#10B981",
    successSoft: "#6EE7B7",
    orange: "#F59E0B",
    orangeSoft: "#FCD34D",
    text: "#F1F5F9",
    textMuted: "#94A3B8",
    textDim: "#64748B",
    border: "#2A3548",
    borderFocus: "#3B82F6",
    white: "#FFFFFF",
  };

  if (submitted) {
    return (
      <div style={{ minHeight: "100vh", background: colors.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif", padding: "2rem" }}>
        <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Space+Grotesk:wght@500;700&display=swap" rel="stylesheet" />
        <div style={{ textAlign: "center", maxWidth: 560 }}>
          <div style={{ width: 80, height: 80, borderRadius: "50%", background: `linear-gradient(135deg, ${colors.success}, #059669)`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 2rem", fontSize: 36 }}>✓</div>
          <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "2rem", color: colors.white, marginBottom: "1rem" }}>Demande reçue</h1>
          <p style={{ color: colors.textMuted, fontSize: "1.1rem", lineHeight: 1.7 }}>
            Votre audit SEO local est en cours de génération.
            <br />Vous recevrez votre rapport complet à <strong style={{ color: colors.accentBright }}>{form.email}</strong> sous 24-48h.
          </p>
          <div style={{ marginTop: "2rem", padding: "1.25rem", background: colors.bgCard, borderRadius: 12, border: `1px solid ${colors.border}` }}>
            <p style={{ color: colors.textDim, fontSize: "0.875rem", margin: 0 }}>
              Vous recevrez : votre score /100, l'analyse de votre fiche Google, votre positionnement Maps sur 20 zones, vos forces et faiblesses, et un plan d'action en 3 phases.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const Field = ({ label, field, required, type = "text", placeholder, help, children }) => (
    <div style={{ marginBottom: "1.25rem" }}>
      <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>
        {label} {required && <span style={{ color: colors.danger }}>*</span>}
      </label>
      {children || (
        <input
          type={type}
          value={form[field]}
          onChange={e => update(field, e.target.value)}
          placeholder={placeholder}
          style={{
            width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem",
            background: colors.bg, border: `1px solid ${errors[field] ? colors.danger : colors.border}`,
            borderRadius: 8, color: colors.text, outline: "none",
            transition: "border-color 0.2s",
            boxSizing: "border-box",
          }}
          onFocus={e => e.target.style.borderColor = errors[field] ? colors.danger : colors.borderFocus}
          onBlur={e => e.target.style.borderColor = errors[field] ? colors.danger : colors.border}
        />
      )}
      {help && !errors[field] && <p style={{ fontSize: "0.8rem", color: colors.textDim, marginTop: 4, marginBottom: 0 }}>{help}</p>}
      {errors[field] && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors[field]}</p>}
    </div>
  );

  const StatBlock = ({ number, label, color: c }) => (
    <div style={{ textAlign: "center", flex: 1 }}>
      <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "2.5rem", fontWeight: 700, color: c, lineHeight: 1 }}>{number}</div>
      <div style={{ fontSize: "0.85rem", color: colors.textMuted, marginTop: 6, lineHeight: 1.4 }}>{label}</div>
    </div>
  );

  const PainCard = ({ icon, title, desc }) => (
    <div style={{
      background: colors.bgCard, borderRadius: 12, padding: "1.5rem",
      border: `1px solid ${colors.border}`, transition: "border-color 0.3s, transform 0.3s",
      cursor: "default",
    }}
    onMouseEnter={e => { e.currentTarget.style.borderColor = colors.accent; e.currentTarget.style.transform = "translateY(-2px)"; }}
    onMouseLeave={e => { e.currentTarget.style.borderColor = colors.border; e.currentTarget.style.transform = "translateY(0)"; }}
    >
      <div style={{ fontSize: "1.75rem", marginBottom: "0.75rem" }}>{icon}</div>
      <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "1.05rem", color: colors.white, marginBottom: "0.5rem", marginTop: 0 }}>{title}</h3>
      <p style={{ fontSize: "0.9rem", color: colors.textMuted, lineHeight: 1.6, margin: 0 }}>{desc}</p>
    </div>
  );

  const AuditBlock = ({ number, title, desc, color: c }) => (
    <div style={{ display: "flex", gap: "1rem", alignItems: "flex-start" }}>
      <div style={{
        minWidth: 40, height: 40, borderRadius: "50%",
        background: `${c}22`, color: c,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1rem",
      }}>{number}</div>
      <div>
        <h4 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "0.95rem", color: colors.white, margin: "0 0 4px 0" }}>{title}</h4>
        <p style={{ fontSize: "0.875rem", color: colors.textMuted, lineHeight: 1.5, margin: 0 }}>{desc}</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: colors.bg, fontFamily: "'DM Sans', sans-serif", color: colors.text }}>
      {/* ==================== ANALYTICS ==================== */}
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`} />
      <script dangerouslySetInnerHTML={{ __html: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}');` }} />
      <script dangerouslySetInnerHTML={{ __html: `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${PIXEL_ID}');fbq('track','PageView');` }} />
      <noscript><img height="1" width="1" style={{ display: "none" }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" /></noscript>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Space+Grotesk:wght@500;700&display=swap" rel="stylesheet" />
      <style>{`
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: ${colors.accent}44; }
        input::placeholder, textarea::placeholder { color: ${colors.textDim}; }
        select { appearance: none; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulseGlow { 0%, 100% { box-shadow: 0 0 20px ${colors.accentGlow}; } 50% { box-shadow: 0 0 40px ${colors.accentGlow}, 0 0 60px ${colors.accentGlow}; } }
        .fade-up { animation: fadeUp 0.6s ease-out both; }
        .fade-up-1 { animation-delay: 0.1s; }
        .fade-up-2 { animation-delay: 0.2s; }
        .fade-up-3 { animation-delay: 0.3s; }
        .fade-up-4 { animation-delay: 0.4s; }
        @media (max-width: 640px) {
          .grid-2col { grid-template-columns: 1fr !important; }
          .hero-section { padding: 3rem 1.25rem 2.5rem !important; }
          .section-padding { padding-left: 1.25rem !important; padding-right: 1.25rem !important; }
          .nav-bar { padding: 0.75rem 1.25rem !important; }
          .stats-row { flex-direction: column !important; gap: 1.5rem !important; }
          .form-card { padding: 1.5rem 1.25rem !important; }
          .cred-grid { grid-template-columns: 1fr 1fr !important; }
          .values-strip { justify-content: flex-start !important; }
        }
      `}</style>

      {/* ==================== NAV ==================== */}
      <nav style={{
        position: "sticky", top: 0, zIndex: 100,
        background: `${colors.bg}ee`, backdropFilter: "blur(12px)",
        borderBottom: `1px solid ${colors.border}`,
        padding: "0.75rem 2rem",
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }} className="nav-bar">
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1.25rem", color: colors.white }}>
          <span style={{ color: colors.accent }}>Rank</span>District
        </div>
        <a href="#audit-form" onClick={e => { e.preventDefault(); document.getElementById('audit-form')?.scrollIntoView({ behavior: 'smooth' }); }} style={{
          padding: "0.5rem 1.25rem", borderRadius: 8,
          background: colors.accent, color: colors.white,
          fontSize: "0.875rem", fontWeight: 600, textDecoration: "none",
          transition: "opacity 0.2s", cursor: "pointer",
        }}
        onMouseEnter={e => e.target.style.opacity = 0.9}
        onMouseLeave={e => e.target.style.opacity = 1}
        >Audit gratuit →</a>
      </nav>

      {/* ==================== HERO ==================== */}
      <section className="hero-section" style={{
        padding: "5rem 2rem 4rem", maxWidth: 900, margin: "0 auto", textAlign: "center",
        position: "relative",
      }}>
        <div style={{
          position: "absolute", top: "20%", left: "50%", transform: "translate(-50%, -50%)",
          width: 500, height: 500, borderRadius: "50%",
          background: `radial-gradient(circle, ${colors.accentGlow} 0%, transparent 70%)`,
          pointerEvents: "none",
        }} />
        <div className="fade-up" style={{ position: "relative" }}>
          <div style={{
            display: "inline-block", padding: "0.4rem 1rem", borderRadius: 100,
            background: `${colors.accent}15`, border: `1px solid ${colors.accent}33`,
            fontSize: "0.8rem", color: colors.accentBright, fontWeight: 500,
            marginBottom: "1.5rem",
          }}>
            Audit SEO local gratuit — Rapport complet en 24-48h
          </div>
          <h1 style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: "clamp(1.75rem, 4vw, 2.75rem)",
            fontWeight: 700, lineHeight: 1.2,
            color: colors.white, marginBottom: "1.5rem",
            maxWidth: 700, margin: "0 auto 1.5rem",
          }}>
            <span style={{ color: colors.accent }}>RankDistrict</span>
            <br />
            <span style={{ whiteSpace: "nowrap" }}>votre score <span style={{ color: colors.accent }}>/100</span></span> GBP + site web
            <br />
            <span style={{ color: colors.accentBright }}>sous 48h.</span>
          </h1>
          <p style={{ fontSize: "1.05rem", color: colors.textMuted, fontWeight: 400, maxWidth: 600, margin: "0 auto", lineHeight: 1.6 }}>
            On analyse votre fiche Google, votre site et vos concurrents — vous recevez un plan d'action concret.
          </p>
        </div>
        <p className="fade-up fade-up-1" style={{
          fontSize: "1.1rem", color: colors.textMuted, lineHeight: 1.7,
          maxWidth: 650, margin: "0 auto 2.5rem",
        }}>
          RankDistrict analyse votre fiche Google, votre positionnement sur 20 zones GPS,
          vos avis, votre site web et vos concurrents directs.
          Vous recevez un score sur 100 et un plan d'action concret.
        </p>

        <a href="#audit-form" onClick={e => { e.preventDefault(); document.getElementById('audit-form')?.scrollIntoView({ behavior: 'smooth' }); }} className="fade-up fade-up-2" style={{
          display: "inline-block", padding: "1rem 2.5rem", borderRadius: 10,
          background: `linear-gradient(135deg, ${colors.accent}, #2563EB)`,
          color: colors.white, fontSize: "1.1rem", fontWeight: 700,
          textDecoration: "none", transition: "transform 0.2s, box-shadow 0.2s",
          boxShadow: `0 4px 24px ${colors.accentGlow}`, cursor: "pointer",
        }}
        onMouseEnter={e => { e.target.style.transform = "translateY(-2px)"; e.target.style.boxShadow = `0 8px 32px ${colors.accentGlow}`; }}
        onMouseLeave={e => { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = `0 4px 24px ${colors.accentGlow}`; }}
        >
          Recevoir mon audit gratuit →
        </a>
        <p className="fade-up fade-up-3" style={{ fontSize: "0.8rem", color: colors.textDim, marginTop: "0.75rem" }}>
          Sans engagement · Sans carte bancaire · Rapport PDF complet
        </p>
      </section>

      {/* ==================== STATS ==================== */}
      <section style={{
        maxWidth: 800, margin: "0 auto 4rem", padding: "0 2rem",
        display: "flex", gap: "1.5rem", flexWrap: "wrap", justifyContent: "center",
      }} className="stats-row">
        {[
          { n: "72%", l: "des clients choisissent un commerce dans un rayon de 8 km", c: colors.accent },
          { n: "2.7×", l: "plus crédible : une fiche Google complète vs incomplète", c: colors.success },
          { n: "50%", l: "des recherches locales mènent à une visite en magasin sous 24h", c: colors.orange },
        ].map((s, i) => <StatBlock key={i} number={s.n} label={s.l} color={s.c} />)}
      </section>

      {/* ==================== DOULEURS ==================== */}
      <section className="section-padding" style={{ maxWidth: 900, margin: "0 auto 5rem", padding: "0 2rem" }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.75rem", fontWeight: 700, color: colors.white,
          textAlign: "center", marginBottom: "0.75rem",
        }}>
          Ces situations vous parlent ?
        </h2>
        <p style={{ textAlign: "center", color: colors.textMuted, marginBottom: "2.5rem", fontSize: "1rem" }}>
          Si oui, votre fiche Google vous coûte des clients chaque jour.
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "1rem" }}>
          <PainCard
            icon="📍"
            title="Invisible sur Google Maps"
            desc="Votre concurrent apparaît en position 1. Vous, vous êtes en page 2 — ou absent. Chaque recherche locale que vous ratez, c'est un client qui va chez lui."
          />
          <PainCard
            icon="⭐"
            title="Des avis qui font mal"
            desc="Un avis 1 étoile sans réponse. Ou pire : une réponse maladroite qui aggrave la situation. Chaque avis négatif non traité repousse vos futurs clients."
          />
          <PainCard
            icon="🔗"
            title="Un site web déconnecté"
            desc="Votre site existe mais Google ne fait pas le lien avec votre fiche. Adresse différente, pas de page locale, pas de balisage technique. Résultat : zéro synergie."
          />
          <PainCard
            icon="⏰"
            title="Pas le temps de s'en occuper"
            desc="Publier des posts Google, répondre aux avis, ajouter des photos, mettre à jour les horaires. Vous avez un business à faire tourner, pas un profil Google à nourrir."
          />
          <PainCard
            icon="🎯"
            title="Des efforts sans résultats"
            desc="Vous avez essayé de modifier votre fiche, d'ajouter des photos, de demander des avis. Mais sans stratégie, ces actions isolées ne changent pas votre classement."
          />
          <PainCard
            icon="🏪"
            title="Vos concurrents avancent"
            desc="Pendant que vous hésitez, vos concurrents optimisent leur fiche, collectent des avis, publient du contenu. L'écart se creuse chaque mois."
          />
        </div>
      </section>

      {/* ==================== CE QUE L'AUDIT ANALYSE ==================== */}
      <section style={{
        maxWidth: 800, margin: "0 auto 5rem", padding: "0 2rem",
      }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.75rem", fontWeight: 700, color: colors.white,
          textAlign: "center", marginBottom: "0.5rem",
        }}>
          Ce que votre audit gratuit contient
        </h2>
        <p style={{ textAlign: "center", color: colors.textMuted, marginBottom: "2.5rem", fontSize: "1rem" }}>
          Un vrai diagnostic, pas un résumé superficiel.
        </p>
        <div style={{
          background: colors.bgCard, borderRadius: 16, border: `1px solid ${colors.border}`,
          padding: "2rem", display: "flex", flexDirection: "column", gap: "1.5rem",
        }}>
          <AuditBlock number="1" title="Score de visibilité /100" desc="Un score pondéré basé sur les facteurs réels de ranking Google Maps : avis, cohérence NAP, catégories, photos, posts, site web, et plus encore." color={colors.accent} />
          <div style={{ height: 1, background: colors.border }} />
          <AuditBlock number="2" title="Positionnement Maps — 20 zones GPS" desc="On scanne votre visibilité sur 20 points autour de votre adresse. Vous voyez exactement où vous apparaissez, où vous êtes absent, et qui vous devance." color={colors.success} />
          <div style={{ height: 1, background: colors.border }} />
          <AuditBlock number="3" title="Analyse concurrence" desc="Vos 3 à 5 concurrents dominants : leur note, leurs avis, leurs catégories, ce qu'ils font que vous ne faites pas. On identifie les gaps à combler." color={colors.orange} />
          <div style={{ height: 1, background: colors.border }} />
          <AuditBlock number="4" title="Audit fiche Google + site web" desc="Cohérence nom/adresse/téléphone, catégories, description, photos, horaires, attributs, balisage technique du site, vitesse mobile." color={colors.danger} />
          <div style={{ height: 1, background: colors.border }} />
          <AuditBlock number="5" title="Plan d'action en 3 phases" desc="Quick wins (semaine 1), actions à moyen terme (mois 1-3), stratégie long terme (mois 3-6). Chaque action est concrète et priorisée par impact." color="#8B5CF6" />
        </div>
      </section>

      {/* ==================== FORMULAIRE ==================== */}
      <section id="audit-form" style={{
        maxWidth: 620, margin: "0 auto 5rem", padding: "0 2rem",
      }}>
        <div style={{
          background: colors.bgCard, borderRadius: 16,
          border: `1px solid ${colors.border}`,
          padding: "2.5rem 2rem",
          boxShadow: `0 0 60px ${colors.accentGlow}`,
        }}>
          <h2 style={{
            fontFamily: "'Space Grotesk', sans-serif",
            fontSize: "1.5rem", fontWeight: 700, color: colors.white,
            textAlign: "center", marginBottom: "0.5rem",
          }}>
            Demandez votre audit gratuit
          </h2>
          <p style={{ textAlign: "center", color: colors.textMuted, fontSize: "0.9rem", marginBottom: "2rem" }}>
            Remplissez le formulaire, on vous envoie votre rapport complet sous 24-48h.
          </p>

          <div onSubmit={handleSubmit}>
            <div className="grid-2col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
              {/* Prénom */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Prénom <span style={{ color: colors.danger }}>*</span></label>
                <input type="text" value={form.prenom} onChange={e => update("prenom", e.target.value)} placeholder="Votre prénom"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.prenom ? colors.danger : colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
                {errors.prenom && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.prenom}</p>}
              </div>
              {/* Entreprise */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Nom de l'entreprise <span style={{ color: colors.danger }}>*</span></label>
                <input type="text" value={form.entreprise} onChange={e => update("entreprise", e.target.value)} placeholder="Ex : La Boulangerie Dorée"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.entreprise ? colors.danger : colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
                {errors.entreprise && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.entreprise}</p>}
              </div>
            </div>

            <div className="grid-2col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
              {/* Email */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Email professionnel <span style={{ color: colors.danger }}>*</span></label>
                <input type="email" value={form.email} onChange={e => update("email", e.target.value)} placeholder="vous@entreprise.fr"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.email ? colors.danger : colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
                {errors.email && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.email}</p>}
              </div>
              {/* Téléphone */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Téléphone</label>
                <input type="text" value={form.telephone} onChange={e => update("telephone", e.target.value)} placeholder="Optionnel"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
              </div>
            </div>

            <div className="grid-2col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
              {/* Ville */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Ville / zone géographique <span style={{ color: colors.danger }}>*</span></label>
                <input type="text" value={form.ville} onChange={e => update("ville", e.target.value)} placeholder="Ex : Lyon 3ème"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.ville ? colors.danger : colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
                {errors.ville && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.ville}</p>}
              </div>
              {/* Secteur */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Secteur d'activité <span style={{ color: colors.danger }}>*</span></label>
                <select value={form.secteur} onChange={e => update("secteur", e.target.value)}
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.secteur ? colors.danger : colors.border}`, borderRadius: 8, color: form.secteur ? colors.text : colors.textDim, outline: "none", cursor: "pointer", boxSizing: "border-box" }}>
                  <option value="" style={{ color: colors.textDim }}>Choisir...</option>
                  {SECTORS.map(s => <option key={s} value={s} style={{ background: colors.bg, color: colors.text }}>{s}</option>)}
                </select>
                {errors.secteur && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.secteur}</p>}
              </div>
            </div>

            {/* GBP URL */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Lien fiche Google Business <span style={{ color: colors.danger }}>*</span></label>
              <input type="text" value={form.gbpUrl} onChange={e => update("gbpUrl", e.target.value)} placeholder="https://www.google.com/maps/place/..."
                style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${errors.gbpUrl ? colors.danger : colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
              {!errors.gbpUrl && <p style={{ fontSize: "0.8rem", color: colors.textDim, marginTop: 4, marginBottom: 0 }}>1/ Ouvrez Google Maps → votre fiche   2/ Copiez l'URL complète (maps.google.com/?cid=...)   3/ Collez ici</p>}
              {errors.gbpUrl && <p style={{ fontSize: "0.8rem", color: colors.dangerSoft, marginTop: 4, marginBottom: 0 }}>{errors.gbpUrl}</p>}
            </div>

            {/* Site web */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Site web</label>
              <input type="text" value={form.siteWeb} onChange={e => update("siteWeb", e.target.value)} placeholder="https://www.votre-site.fr"
                style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
              <p style={{ fontSize: "0.8rem", color: colors.textDim, marginTop: 4, marginBottom: 0 }}>Optionnel mais recommandé — nous permet d'analyser la cohérence site/fiche.</p>
            </div>

            <div className="grid-2col" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 1rem" }}>
              {/* Date début */}
              <div style={{ marginBottom: "1.25rem" }}>
                <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Année de début d'activité</label>
                <input type="text" value={form.dateDebut} onChange={e => update("dateDebut", e.target.value)} placeholder="Ex : 2018"
                  style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.text, outline: "none", boxSizing: "border-box" }} />
                <p style={{ fontSize: "0.8rem", color: colors.textDim, marginTop: 4, marginBottom: 0 }}>Optionnel — aide à comparer avec des entreprises similaires.</p>
              </div>
              <div />
            </div>

            {/* Message */}
            <div style={{ marginBottom: "1.25rem" }}>
              <label style={{ display: "block", fontSize: "0.875rem", fontWeight: 500, color: colors.text, marginBottom: 6 }}>Message</label>
              <textarea value={form.message} onChange={e => update("message", e.target.value)}
                placeholder="Ouverture récente, forte concurrence, problème d'avis négatifs... Dites-nous ce qui vous préoccupe."
                rows={3}
                style={{ width: "100%", padding: "0.75rem 1rem", fontSize: "0.95rem", background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, color: colors.text, outline: "none", resize: "vertical", fontFamily: "'DM Sans', sans-serif", boxSizing: "border-box" }} />
            </div>

            <button
              onClick={handleSubmit}
              disabled={submitting}
              style={{
                width: "100%", padding: "1rem", borderRadius: 10,
                background: submitting ? colors.textDim : `linear-gradient(135deg, ${colors.accent}, #2563EB)`,
                color: colors.white, fontSize: "1.05rem", fontWeight: 700,
                border: "none", cursor: submitting ? "not-allowed" : "pointer",
                transition: "transform 0.2s, box-shadow 0.2s",
                boxShadow: submitting ? "none" : `0 4px 20px ${colors.accentGlow}`,
                marginTop: "0.5rem",
                opacity: submitting ? 0.7 : 1,
              }}
              onMouseEnter={e => { if (!submitting) { e.target.style.transform = "translateY(-1px)"; e.target.style.boxShadow = `0 8px 32px ${colors.accentGlow}`; } }}
              onMouseLeave={e => { if (!submitting) { e.target.style.transform = "translateY(0)"; e.target.style.boxShadow = `0 4px 20px ${colors.accentGlow}`; } }}
            >
              {submitting ? "Envoi en cours..." : "Recevoir mon audit gratuit →"}
            </button>
            <p style={{ textAlign: "center", fontSize: "0.8rem", color: colors.textDim, marginTop: "0.75rem" }}>
              🔒 Vos données restent confidentielles. Pas de spam, pas de revente.
            </p>
          </div>
        </div>
      </section>

      {/* ==================== PROCESS ==================== */}
      <section className="section-padding" style={{ maxWidth: 800, margin: "0 auto 5rem", padding: "0 2rem" }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.75rem", fontWeight: 700, color: colors.white,
          textAlign: "center", marginBottom: "2.5rem",
        }}>
          Comment ça marche
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          {[
            { step: "01", title: "Vous remplissez le formulaire", desc: "30 secondes. On a juste besoin de votre fiche Google et de quelques infos basiques.", icon: "📋" },
            { step: "02", title: "On analyse tout automatiquement", desc: "Notre outil scanne votre fiche Google, votre positionnement sur 20 zones GPS, vos concurrents, vos mots-clés, et votre site web.", icon: "🔍" },
            { step: "03", title: "Vous recevez votre rapport PDF", desc: "Sous 24-48h : votre score /100, vos forces, vos faiblesses, et un plan d'action en 3 phases. Clair, visuel, actionnable.", icon: "📊" },
          ].map((s, i) => (
            <div key={i} style={{
              display: "flex", gap: "1.25rem", alignItems: "flex-start",
              padding: "1.25rem", background: colors.bgCard,
              borderRadius: 12, border: `1px solid ${colors.border}`,
            }}>
              <div style={{
                minWidth: 48, height: 48, borderRadius: 12,
                background: `${colors.accent}15`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: "1.5rem",
              }}>{s.icon}</div>
              <div>
                <div style={{ fontSize: "0.75rem", color: colors.accent, fontWeight: 700, fontFamily: "'Space Grotesk', sans-serif", marginBottom: 4 }}>ÉTAPE {s.step}</div>
                <h3 style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "1rem", color: colors.white, margin: "0 0 4px 0" }}>{s.title}</h3>
                <p style={{ fontSize: "0.875rem", color: colors.textMuted, lineHeight: 1.5, margin: 0 }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ==================== FAQ ==================== */}
      <section className="section-padding" style={{ maxWidth: 700, margin: "0 auto 5rem", padding: "0 2rem" }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.75rem", fontWeight: 700, color: colors.white,
          textAlign: "center", marginBottom: "2rem",
        }}>
          Questions fréquentes
        </h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          {faqData.map((item, i) => (
            <div key={i} style={{
              background: colors.bgCard, borderRadius: 10,
              border: `1px solid ${activeQuestion === i ? colors.accent + "44" : colors.border}`,
              overflow: "hidden", transition: "border-color 0.3s",
            }}>
              <button
                onClick={() => setActiveQuestion(activeQuestion === i ? null : i)}
                style={{
                  width: "100%", padding: "1rem 1.25rem",
                  background: "transparent", border: "none",
                  color: colors.white, fontSize: "0.95rem", fontWeight: 500,
                  textAlign: "left", cursor: "pointer",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                {item.q}
                <span style={{
                  fontSize: "1.25rem", color: colors.textDim,
                  transform: activeQuestion === i ? "rotate(45deg)" : "rotate(0)",
                  transition: "transform 0.3s",
                }}>+</span>
              </button>
              {activeQuestion === i && (
                <div style={{ padding: "0 1.25rem 1rem", fontSize: "0.9rem", color: colors.textMuted, lineHeight: 1.6 }}>
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* ==================== QUI SOMMES-NOUS ==================== */}
      <section className="section-padding" style={{ maxWidth: 900, margin: "0 auto 5rem", padding: "0 2rem" }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.75rem", fontWeight: 700, color: colors.white,
          textAlign: "center", marginBottom: "0.5rem",
        }}>
          Pourquoi RankDistrict
        </h2>
        <p style={{ textAlign: "center", color: colors.textMuted, fontSize: "1rem", marginBottom: "2.5rem" }}>
          Pas une agence de plus. Un outil construit par des gens qui connaissent le terrain.
        </p>

        {/* Pitch block */}
        <div style={{
          background: colors.bgCard, borderRadius: 16,
          border: `1px solid ${colors.border}`, padding: "2rem",
          marginBottom: "2rem",
        }}>
          <p style={{ fontSize: "1.05rem", color: colors.text, lineHeight: 1.8, marginBottom: "1rem" }}>
            RankDistrict est né d'un constat simple : <strong style={{ color: colors.white }}>les entreprises locales investissent dans leur activité, pas dans leur visibilité Google.</strong> Et quand elles s'y intéressent, elles tombent sur du jargon SEO, des outils complexes, ou des prestataires qui facturent sans expliquer.
          </p>
          <p style={{ fontSize: "1.05rem", color: colors.text, lineHeight: 1.8, margin: 0 }}>
            Notre équipe combine <strong style={{ color: colors.white }}>expertise SEO local, expérience en stratégie d'entreprise et connaissance du terrain</strong> — en France et à l'international. On a travaillé avec des commerces, des artisans, des professions libérales et des franchises. On sait ce qui marche parce qu'on l'a vu fonctionner sur de vraies fiches, dans de vrais quartiers, avec de vrais clients.
          </p>
        </div>

        {/* Credibility pillars */}
        <div className="cred-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "2rem" }}>
          {[
            { icon: "🔍", value: "100+", label: "fiches analysées", desc: "Restaurants, artisans, médecins, commerces, franchises" },
            { icon: "📍", value: "20", label: "zones GPS par audit", desc: "Pas un test superficiel — une vraie cartographie de votre visibilité" },
            { icon: "🤖", value: "IA + Data", label: "Google officielle", desc: "Analyse automatisée par IA, données issues exclusivement des APIs Google" },
            { icon: "🎯", value: "0%", label: "de bullshit", desc: "Pas de promesses irréalistes. Des constats, des chiffres, des actions concrètes" },
          ].map((item, i) => (
            <div key={i} style={{
              background: colors.bgCard, borderRadius: 12, padding: "1.25rem",
              border: `1px solid ${colors.border}`, textAlign: "center",
            }}>
              <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>{item.icon}</div>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: "1.5rem", fontWeight: 700, color: colors.accent }}>{item.value}</div>
              <div style={{ fontSize: "0.9rem", fontWeight: 600, color: colors.white, marginBottom: 4 }}>{item.label}</div>
              <div style={{ fontSize: "0.8rem", color: colors.textMuted, lineHeight: 1.4 }}>{item.desc}</div>
            </div>
          ))}
        </div>

        {/* Values strip */}
        <div style={{
          display: "flex", flexWrap: "wrap", gap: "0.75rem", justifyContent: "center",
        }} className="values-strip">
          {[
            "Transparence totale sur nos méthodes",
            "Résultats mesurables, pas du vent",
            "Spécialistes Google Business Profile",
            "Accompagnement humain, pas un robot",
            "Expérience France + international",
          ].map((v, i) => (
            <span key={i} style={{
              padding: "0.5rem 1rem", borderRadius: 100,
              background: `${colors.accent}10`, border: `1px solid ${colors.accent}25`,
              fontSize: "0.8rem", color: colors.accentBright, fontWeight: 500,
            }}>
              ✓ {v}
            </span>
          ))}
        </div>
      </section>

      {/* ==================== FINAL CTA ==================== */}
      <section style={{
        maxWidth: 700, margin: "0 auto 4rem", padding: "2.5rem 2rem",
        textAlign: "center",
        background: `linear-gradient(135deg, ${colors.accent}11, ${colors.accent}05)`,
        borderRadius: 20, border: `1px solid ${colors.accent}22`,
      }}>
        <h2 style={{
          fontFamily: "'Space Grotesk', sans-serif",
          fontSize: "1.5rem", fontWeight: 700, color: colors.white,
          marginBottom: "0.75rem",
        }}>
          Chaque jour sans optimisation, c'est des clients que vous laissez à vos concurrents.
        </h2>
        <p style={{ color: colors.textMuted, marginBottom: "1.5rem", fontSize: "1rem" }}>
          L'audit est gratuit, sans engagement, et vous donne une feuille de route claire.
        </p>
        <a href="#audit-form" onClick={e => { e.preventDefault(); document.getElementById('audit-form')?.scrollIntoView({ behavior: 'smooth' }); }} style={{
          display: "inline-block", padding: "1rem 2.5rem", borderRadius: 10,
          background: `linear-gradient(135deg, ${colors.accent}, #2563EB)`,
          color: colors.white, fontSize: "1.05rem", fontWeight: 700,
          textDecoration: "none", cursor: "pointer",
          boxShadow: `0 4px 24px ${colors.accentGlow}`,
        }}>
          Demander mon audit gratuit →
        </a>
      </section>

      {/* ==================== FOOTER ==================== */}
      <footer style={{
        borderTop: `1px solid ${colors.border}`,
        padding: "2rem", textAlign: "center",
      }}>
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "1.1rem", color: colors.white, marginBottom: "0.5rem" }}>
          <span style={{ color: colors.accent }}>Rank</span>District
        </div>
        <p style={{ fontSize: "0.8rem", color: colors.textDim }}>
          Audit et optimisation SEO local · Google Business Profile
        </p>
        <p style={{ fontSize: "0.75rem", color: colors.textDim, marginTop: "0.75rem" }}>
          © 2026 RankDistrict. Tous droits réservés.
        </p>
      </footer>
    </div>
  );
}
